import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-soft-gray">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hero/hero.jpg"
          alt="Custom T-shirts"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/80 via-charcoal/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-primary-pink/20 backdrop-blur-sm border border-primary-pink/40 rounded-full px-4 py-2 mb-8">
            <Sparkles size={16} className="text-primary-pink" />
            <span className="text-sm font-medium tracking-wide text-cream-white">
              DISEÑOS QUE MOTIVAN
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="hero-title text-5xl md:text-6xl lg:text-7xl font-serif text-cream-white mb-6 leading-tight">
            <span className="relative inline-block">
              <span className="absolute -inset-x-3 -inset-y-2 -z-10 rounded-2xl bg-black/55 backdrop-blur-md" />
              Estampados DTF
            </span>

            <br />

            <span className="relative inline-block text-primary-pink">
              <span className="absolute -inset-x-3 -inset-y-2 -z-10 rounded-2xl bg-black/45 backdrop-blur-md" />
              Únicos y Personalizados
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl md:text-2xl text-cream-white/90 mb-8 leading-relaxed max-w-2xl font-light">
            Transformamos tus ideas en diseños de alta calidad. 
            Remeras, buzos y más con la mejor tecnología DTF.
          </p>

          {/* Features List */}
          <div className="flex flex-wrap gap-6 mb-10">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary-pink rounded-full"></div>
              <span className="text-cream-white/90 text-sm tracking-wide">Colores Vivos</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary-pink rounded-full"></div>
              <span className="text-cream-white/90 text-sm tracking-wide">Detalle Fino</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary-pink rounded-full"></div>
              <span className="text-cream-white/90 text-sm tracking-wide">Durabilidad Real</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollToSection('cotizacion')}
              className="bg-primary-pink hover:bg-primary-pink/90 text-cream-white px-8 py-6 text-base font-medium tracking-wide rounded shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
            >
              COTIZAR AHORA
              <ArrowRight size={20} />
            </Button>
            <Button
              onClick={() => scrollToSection('catalogo')}
              variant="outline"
              className="border-2 border-cream-white text-cream-white hover:bg-cream-white hover:text-charcoal px-8 py-6 text-base font-medium tracking-wide rounded transition-all duration-300"
            >
              VER CATÁLOGO
            </Button>
          </div>

          {/* Trust Badge */}
          <div className="mt-12 flex items-center gap-4">
            <div className="flex -space-x-2">
              <div className="w-10 h-10 rounded-full bg-primary-pink border-2 border-cream-white"></div>
              <div className="w-10 h-10 rounded-full bg-dusty-rose border-2 border-cream-white"></div>
              <div className="w-10 h-10 rounded-full bg-deep-navy border-2 border-cream-white"></div>
            </div>
            <div>
              <p className="text-cream-white font-medium">+100 Clientes Satisfechos</p>
              <p className="text-cream-white/70 text-sm">Con garantía de calidad</p>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cream-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
